export const nullDate = {
    year: 1899,
    month: 12,
    day: 30
};


// WEBPACK FOOTER //
// ./src/common/src/common.js